import React from "react";
import {toggleFilterMenu} from "../../utils/filters";

const AdvancedFilterMenuOverlay = () => (
    <div className="b-recipes-advanced-filter__filter-menu-overlay js-filter-menu-overlay" onClick={toggleFilterMenu}></div>
)
export default AdvancedFilterMenuOverlay;
